import { EmploymentType } from '@zorro/clients';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { employmentTypeLabelConfig } from '@zorro/types';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

const employmentTypeOptions = Object.values(EmploymentType).map((status) => ({
  label: employmentTypeLabelConfig[status],
  value: status,
}));

type EmploymentTypeFieldValues = {
  employmentType?: EmploymentType | null;
};
type Props<T extends EmploymentTypeFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & { selectProps?: SelectProps };

export const EmploymentTypeInput = forwardRef(
  <T extends EmploymentTypeFieldValues, U extends Path<T>>(
    { selectProps, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Select
        {...field}
        {...selectProps}
        ref={ref}
        size="lg"
        label="Employment type"
        placeholder="Select employment type"
        data={employmentTypeOptions}
      />
    );
  }
);

EmploymentTypeInput.displayName = 'MaritalStatusInput';
